export interface DeductionTypeCategoryProps {
  deductionTypeCategoryId: number;
  deductionTypeCategoryKey: string;
  deductionTypeCategoryName: string;
}

export class DeductionTypeCategory {
  private readonly _deductionTypeCategoryId: number;
  private readonly _deductionTypeCategoryKey: string;
  private readonly _deductionTypeCategoryName: string;

  constructor(props: DeductionTypeCategoryProps) {
    this._deductionTypeCategoryId = props.deductionTypeCategoryId;
    this._deductionTypeCategoryKey = props.deductionTypeCategoryKey;
    this._deductionTypeCategoryName = props.deductionTypeCategoryName;
  }

  public get deductionTypeCategoryId(): number {
    return this._deductionTypeCategoryId;
  }

  public get deductionTypeCategoryKey(): string {
    return this._deductionTypeCategoryKey;
  }

  public get deductionTypeCategoryName(): string {
    return this._deductionTypeCategoryName;
  }
}
